import {gsap} from "gsap";
import connexion from "./connexion";
import scroll from "./scroll";

const menu = {
    open: false,

    init() {
        let _this = this;

        $(document).on("click", ".__logo", function () {
            let _anchor = "hero";
            scroll.locomotiveScroll.scrollTo("#" + _anchor, {duration: .8, offset: -100, disableLerp: true});
        });

        $(document).on("click", ".nav > li,.__anchor,._execo_btn", function () {
            let _anchor = $(this).data("anchor");
            scroll.locomotiveScroll.scrollTo("#" + _anchor, {duration: .8, offset: -100, disableLerp: true});
        });

        $(document).on("click", ".ham", function () {
            $(this).toggleClass("_open");
            $("._nav_mobile").toggleClass("_open");
        });

        $(document).on("click", "._nav_mobile > ._item", function () {
            let _anchor = $(this).data("anchor");
            scroll.locomotiveScroll.scrollTo("#" + _anchor, {duration: .8, offset: -100, disableLerp: true});
            _this.closeMobile();
        });

    },
    closeMobile() {
        $(".ham,._nav_mobile").removeClass("_open");
    }
};

export default menu;
